import { Pressable } from 'native-base'
import { useCallback } from 'react'

import { colors } from '../../utils/theme/configureTheme'

interface CustomSwitchProps {
  isChecked: boolean
  onToggle: (value: boolean) => void
  offTrackColor?: string
  onTrackColor?: string
}

/** Styled toggle switch with configurable on/off track colors. */
export default function CustomSwitch({
  isChecked,
  onToggle,
  offTrackColor = '#5D5D5A',
  onTrackColor = colors.brand.selectedBlue,
}: CustomSwitchProps) {
  const handlePress = useCallback(() => {
    onToggle(!isChecked)
  }, [isChecked, onToggle])

  return (
    <Pressable
      onPress={handlePress}
      accessibilityRole="switch"
      accessibilityState={{ checked: isChecked }}
      borderRadius="10px"
    >
      <div
        style={{
          width: '40px',
          height: '20px',
          borderRadius: '10px',
          backgroundColor: isChecked ? onTrackColor : offTrackColor,
          position: 'relative',
          transition: 'background-color 0.2s ease-in-out',
        }}
      >
        <div
          style={{
            position: 'absolute',
            width: '16px',
            height: '16px',
            borderRadius: '8px',
            backgroundColor: 'white',
            left: isChecked ? '22px' : '2px',
            top: '2px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            transition: 'left 0.2s ease-in-out',
          }}
        />
      </div>
    </Pressable>
  )
}
